import qs from 'qs'
export default {
	install(Vue, options) {
		//正则匹配
		Vue.prototype.regex = function(type, string, pattern) {
			switch(type) {
				case 'num': //数字
					pattern = /^[0-9]+$/;
					break;
				case 'phone': //手机号码
					pattern = /^1[3456789]\d{9}$/;
					break;
				case 'password': //密码可以全数字或全字母 特殊字符~!@#$%^&*.
					pattern = /^[\@A-Za-z0-9\!\#\$\%\^\&\*\.\~]{6,22}$/;
					break;
				case 'username': //用户名
					pattern = /^[a-zA-Z0-9_]{3,16}$/;
					break;
				case 'email': //用户名
					pattern = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
					break;
				case 'chinese': //中文
					pattern = /^[\u4e00-\u9fa5]+$/;
					break;
				case 'id_card': //15或18位身份证
					pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}X|x$)/;
					break;
				case 'bank_card': //银行卡16或19位
					pattern = /^(\d{16}|\d{19})$/;
					break;
				case 'money': //金额  正数2位小数
					pattern = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
					break;
				default:
					break;
			}
			if(!pattern.test(string)) {
				return false;
			} else {
				return true;
			}
		}
		//根据时间戳获取年月日
		Vue.prototype.getTimes = function(t) {
			var t1 = new Date(t * 1000);
			var y1 = t1.getFullYear();
			var m1 = (t1.getMonth() + 1) < 10 ? '0' + (t1.getMonth() + 1) : t1.getMonth() + 1;
			var d1 = t1.getDate() < 10 ? '0' + t1.getDate() : t1.getDate();
			var h1 = t1.getHours() < 10 ? '0' + t1.getHours() : t1.getHours();
			var mm1 = t1.getMinutes() < 10 ? '0' + t1.getMinutes() : t1.getMinutes();
			var s1 = t1.getSeconds() < 10 ? '0' + t1.getSeconds() : t1.getSeconds();
			var time = y1 + '-' + m1 + '-' + d1 + '  ' + h1 + ':' + mm1 + ':' + s1;
			return time;
		}
		//根据时间戳获取年月日
		Vue.prototype.getTimes2 = function(t) {
			var t1 = new Date(t * 1000);
			var y1 = t1.getFullYear();
			var m1 = (t1.getMonth() + 1) < 10 ? '0' + (t1.getMonth() + 1) : t1.getMonth() + 1;
			var d1 = t1.getDate() < 10 ? '0' + t1.getDate() : t1.getDate();
			var h1 = t1.getHours() < 10 ? '0' + t1.getHours() : t1.getHours();
			var mm1 = t1.getMinutes() < 10 ? '0' + t1.getMinutes() : t1.getMinutes();
			var s1 = t1.getSeconds() < 10 ? '0' + t1.getSeconds() : t1.getSeconds();
			var time = y1 + '-' + m1 + '-' + d1 + '  ' + h1 + ':' + mm1;
			return time;
		}
		//数组去重
		Vue.prototype.uniq = function(array) {
			var temp = [];
			var l = array.length;
			for(var i = 0; i < l; i++) {
				for(var j = i + 1; j < l; j++) {
					if(array[i] == array[j]) {
						i++;
						j = i;
					}
				}
				temp.push(array[i]);
			}
			return temp;
		}
		//设置cookie
		Vue.prototype.setCookie = function(name, value, time) {
			var d = new Date();
			d.setTime(d.getTime() + time);
			var expires = "expires=" + d.toGMTString();
			if(time) {
				document.cookie = name + "=" + value + "; " + expires;
			} else {
				document.cookie = name + "=" + value;
			}
		}
		//获取cookie;
		Vue.prototype.getCookie = function(name) {
			var name = name + "=";
			var ca = document.cookie.split(';');
			for(var i = 0; i < ca.length; i++) {
				var c = ca[i].trim();
				if(c.indexOf(name) == 0) return c.substring(name.length, c.length);
			}
			return "";
		}
		//删除cookie
		Vue.prototype.delCookie = function(name) {
			var exp = new Date();
			exp.setTime(exp.getTime() - 1000);
			var cval = this.getCookie(name);
			if(cval != null)
				document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/units.js